import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Character } from "./Character";

export class CharacterComponent extends AbstractDisplayComponent {
    private container: Character;

    public override init() {
        let config = {
            labelName: "characterComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1379,
                posY: 779,
                scale: 1,
            },
            portrait: {
                posX: 1075,
                posY: 1337,
                scale: 1,
            }
        };

        super.init();
        this.container = new Character(config);
    }



    public getInstance(): Container {

        return this.container;

    }



    public override destroy(): void {

        this.container.destroy({ children: true });

    }



    public animateCharacter(variant?: string): void {

        this.container.animateCharacter(variant);

    }

    public playShoot(fire: number): void {

        this.container.playShoot(fire);

    }

}

